export const getHighlightedColor = (color) => {
  return 'blue'
}
